<template>
    <div class="til">
        <div class="icon">
            <img src="@/assets/img/students-cap.png" alt="">
        </div>
        <div>
            <slot>標題</slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Til'
}
</script>

<style lang="less" scoped>
.til {
    height: 28px;
    margin: 12px 21px;
    line-height: 28px;
    font-size: 20px;
    font-weight: bold;
    div {
        float: left;
    }
    .icon {
        margin-right: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Til.vue